import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"margin":"20px 0"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Filter ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Display Attribute")
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { class: "mr-10" }, [
  /*#__PURE__*/_createVNode("strong", null, "Target: ")
], -1)
const _hoisted_5 = {
  key: 0,
  class: "box-card"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Search ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Clear ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" View Detail ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_popover = _resolveComponent("el-popover")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 18 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                size: "small",
                type: "primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showFilter = !_ctx.showFilter))
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_el_popover, {
                placement: "bottom",
                width: 400,
                trigger: "click"
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "warning",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox_group, {
                        span: 12,
                        modelValue: _ctx.defaultAttributeSelected,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.defaultAttributeSelected = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listAttributes, (attr) => {
                            return (_openBlock(), _createBlock(_component_el_checkbox, {
                              label: attr.name,
                              key: attr.name,
                              name: "type"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(attr.name.charAt(0).toUpperCase() + attr.name.slice(1)), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.connectionTarget.length > 0)
            ? (_openBlock(), _createBlock(_component_el_col, {
                key: 0,
                span: 8
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form, { style: {"text-align":"right"} }, {
                    default: _withCtx(() => [
                      _hoisted_4,
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.targetSelected,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.targetSelected = $event)),
                        placeholder: "Select",
                        size: "small",
                        onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getSearchData()))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.connectionTarget, (connect, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: index,
                              label: connect.name,
                              value: connect._id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    (_ctx.showFilter)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode(_component_el_form, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, { gutter: 20 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "SKU" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.condition.sku,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.condition.sku = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "Title" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.condition.title,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.condition.title = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { gutter: 20 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "success",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getSearchData()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "primary",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleClear()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listData, (item) => {
      return (_openBlock(), _createBlock(_component_el_card, {
        key: item.id,
        shadow: "hover",
        style: {"margin":"20px 0"}
      }, {
        default: _withCtx(() => [
          _createVNode("div", null, [
            _createVNode("h3", null, "SKU: " + _toDisplayString(item.sku), 1),
            _createVNode("p", null, "Title: " + _toDisplayString(item.title), 1),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.defaultAttributeSelected, (attr, index) => {
              return (_openBlock(), _createBlock("div", { key: index }, [
                _createVNode("strong", null, _toDisplayString(attr.charAt(0).toUpperCase() + attr.slice(1)) + ":", 1),
                _createTextVNode(" " + _toDisplayString(item[attr]), 1)
              ]))
            }), 128)),
            _createVNode(_component_el_button, {
              size: "small",
              onClick: ($event: any) => (_ctx.handleOpenProductDetail(item)),
              type: "primary"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        _: 2
      }, 1024))
    }), 128)),
    _createVNode(_component_el_dialog, {
      title: _ctx.titleModal,
      modelValue: _ctx.dialogProductDetail,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.dialogProductDetail = $event)),
      width: "1000px"
    }, null, 8, ["title", "modelValue"])
  ], 64))
}